import React from 'react';

import ClassAImg from '@/assets/great/class-a.jpg';
import ComputerImg from '@/assets/great/computer.jpg';
import SuntreesImg from '@/assets/great/sun-trees.jpg';

import ResponsiveImage from '../utility/ResponsiveImage/ResponsiveImage';
import css from './HeroImages.module.css';

const Hero = () => (
  <div className={css.images}>
    <div className={css.image1}>
      <ResponsiveImage
        src={ClassAImg.src}
        alt="Class A RV"
        priority={true}
        withFetchPriority="high"
      />
    </div>
    <div className={css.image2}>
      <ResponsiveImage
        src={SuntreesImg.src}
        alt="Outdoor scenery"
        priority={true}
        withFetchPriority="high"
      />
    </div>
    <div className={css.image3}>
      <ResponsiveImage
        src={ComputerImg.src}
        alt="Planning an RV trip"
        priority={true}
        withFetchPriority="high"
      />
    </div>
  </div>
);

export default Hero;
